import React from "react";
import PresetMenuItem from "./PresetMenuItem";
import {MenuItemStyleProps} from "components/DateRangeDropdown/types";

interface WeeksMenuProps {
    selectedData: string;
    setSelectedData: (label: string) => void;
    menuItemStyle?: MenuItemStyleProps;
}

const WeeksMenu: React.FC<WeeksMenuProps> = ({ selectedData, setSelectedData, menuItemStyle }) => {
    return <PresetMenuItem category="Weeks" selectedData={selectedData} setSelectedData={setSelectedData} menuItemStyle={menuItemStyle} />;
};

export default WeeksMenu;